import {
    Box,
    Grid,
    Typography
} from "@mui/material";
import ServicioCard from "./ServicioCard";

const servicios = [
    {
        titulo: "AHORRO",
        descripcion: "Guarda hoy para lograr más mañana",
        detalle:
            "Diseña metas financieras sólidas mediante planes de ahorro flexibles que te permitan construir un futuro con mayor tranquilidad y seguridad.",
        imagen: "/img/ahorro.png",
    },
    {
        titulo: "INVERSIÓN",
        descripcion: "Haz que tu dinero trabaje para ti",
        detalle:
            "Incrementa tu patrimonio aprovechando oportunidades de inversión diseñadas para ayudarte a alcanzar tus objetivos financieros.",
        imagen: "/img/inversion.png",
    },
    {
        titulo: "EDUCACIÓN FINANCIERA",
        descripcion: "Conocimiento para tomar mejores decisiones",
        detalle:
            "Aprende a administrar tus recursos, controlar gastos y desarrollar hábitos que impulsen tu bienestar económico.",
        imagen: "/img/educacion-financiera.png",
    },
    {
        titulo: "PRÉSTAMOS",
        descripcion: "Apoyo financiero cuando más lo necesitas",
        detalle:
            "Obtén acceso a soluciones de financiamiento ágiles y transparentes para enfrentar proyectos, emergencias o nuevas oportunidades.",
        imagen: "/img/prestamos.png",
    }
];

const Servicios = () => {
    return (
        <Box
            sx={{
                background: `
                    linear-gradient(
                        90deg,
                        #f7fdf3 0%,
                        #ecf8e5 25%,
                        #dcf4ce 50%,
                        #c8efb3 75%,
                        #b8e28a 100%
                    )
                `,
            }}
        >
            <Typography
                sx={{
                    color: "#4e6b4d",
                    textAlign: 'center',
                    fontSize: {
                        xs: "2rem",
                        md: "3rem",
                    },
                    fontWeight: 300,
                    pt: 3,
                }}
            >
                Nuestros servicios
            </Typography>

            <Grid container>

                {servicios.map((item) => (
                    <Grid
                        key={item.titulo}
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3
                        }}
                    >
                        <ServicioCard item={item} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Servicios;